import { render } from "./MedicoForm.vue?vue&type=template&id=0a3ac05f&scoped=true"
import script from "./MedicoForm.vue?vue&type=script&lang=js"
export * from "./MedicoForm.vue?vue&type=script&lang=js"

import "@/assets/css/listaFiltrada.css?vue&type=style&index=0&id=0a3ac05f&scoped=true&lang=css"

import exportComponent from "C:\\Software\\Aplicaciones\\kiatros\\frontend\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0a3ac05f"]])

export default __exports__